import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { getEdgeOffering, getEdgeOfferings, patchExistingEdgeOffering, postNewEdgeOffering, removeEdgeOffering } from './data';
import { errorReceiveCreateEdgeOffering, errorReceiveEdgeOffering, errorReceiveEdgeOfferings, errorReceiveModifyEdgeOffering, errorReceiveRemoveEdgeOffering, errorReceiveTargetProfileEdgeOfferings, failedReceiveCreateEdgeOffering, failedReceiveEdgeOffering, failedReceiveEdgeOfferings, failedReceiveModifyEdgeOffering, failedReceiveRemoveEdgeOffering, failedReceiveTargetProfileEdgeOfferings, receiveCreateEdgeOffering, receiveEdgeOffering, receiveEdgeOfferings, receiveModifyEdgeOffering, receiveRemoveEdgeOffering, receiveTargetProfileEdgeOfferings } from './slice';
export function* requestCreateEdgeOffering(action) {
    try {
        const { consumerAPI, edgeOfferingPayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(postNewEdgeOffering, organization, edgeOfferingPayload, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveCreateEdgeOffering());
                yield put(appDanger(t('ERROR_REQUEST_CREATE_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveCreateEdgeOffering(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CREATE_EDGE_OFFERING', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveCreateEdgeOffering());
                yield put(appDanger(t('ERROR_REQUEST_CREATE_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveCreateEdgeOffering(response.data));
                yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CREATE_EDGE_OFFERING', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveCreateEdgeOffering());
    }
}
export function* requestEdgeOffering(action) {
    try {
        const { consumerAPI, edgeOfferingId, targetOrganization } = action.payload;
        const response = yield call(getEdgeOffering, targetOrganization, edgeOfferingId, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveEdgeOffering());
            }
            else if (data) {
                yield put(receiveEdgeOffering(data));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_EDGE_OFFERING', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveEdgeOffering());
            }
            else if (response && response.status === 200) {
                yield put(receiveEdgeOffering(response.data));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_EDGE_OFFERING', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveEdgeOffering());
    }
}
export function* requestEdgeOfferings(action) {
    try {
        const { consumerAPI, kexProfileId, targetOrganization } = action.payload;
        const response = yield call(getEdgeOfferings, targetOrganization, kexProfileId, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveEdgeOfferings());
            }
            else if (data) {
                yield put(receiveEdgeOfferings(data));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_EDGE_OFFERINGS', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveEdgeOfferings());
            }
            else if (response && response.status === 200) {
                yield put(receiveEdgeOfferings(response.data));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_EDGE_OFFERINGS', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveEdgeOfferings());
    }
}
export function* requestTargetProfileEdgeOfferings(action) {
    try {
        const { consumerAPI, kexProfileId, targetOrganization } = action.payload;
        const response = yield call(getEdgeOfferings, targetOrganization, kexProfileId, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveTargetProfileEdgeOfferings());
            }
            else if (data) {
                yield put(receiveTargetProfileEdgeOfferings(data));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_EDGE_OFFERINGS', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveTargetProfileEdgeOfferings());
            }
            else if (response && response.status === 200) {
                yield put(receiveTargetProfileEdgeOfferings(response.data));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_EDGE_OFFERINGS', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveTargetProfileEdgeOfferings());
    }
}
export function* requestModifyEdgeOffering(action) {
    try {
        const { consumerAPI, edgeOfferingId, edgeOfferingPayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(patchExistingEdgeOffering, organization, edgeOfferingId, edgeOfferingPayload, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveModifyEdgeOffering());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveModifyEdgeOffering(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_EDGE_OFFERING', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveModifyEdgeOffering());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveModifyEdgeOffering(response.data));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_EDGE_OFFERING', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveModifyEdgeOffering());
    }
}
export function* requestRemoveEdgeOffering(action) {
    try {
        const { consumerAPI, edgeOfferingId } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(removeEdgeOffering, organization, edgeOfferingId, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveRemoveEdgeOffering());
                yield put(appDanger(t('ERROR_REQUEST_REMOVE_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveRemoveEdgeOffering(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_REMOVE_EDGE_OFFERING', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 204) {
                yield put(errorReceiveRemoveEdgeOffering());
                yield put(appDanger(t('ERROR_REQUEST_REMOVE_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 204) {
                yield put(receiveRemoveEdgeOffering(edgeOfferingId));
                yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_EDGE_OFFERING', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_REMOVE_EDGE_OFFERING', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveRemoveEdgeOffering());
    }
}
export function* watchRequestCreateEdgeOffering() {
    yield takeLatest('edgeOfferings/requestCreateEdgeOffering', requestCreateEdgeOffering);
}
export function* watchRequestEdgeOffering() {
    yield takeLatest('edgeOfferings/requestEdgeOffering', requestEdgeOffering);
}
export function* watchRequestEdgeOfferings() {
    yield takeLatest('edgeOfferings/requestEdgeOfferings', requestEdgeOfferings);
}
export function* watchRequestModifyEdgeOffering() {
    yield takeLatest('edgeOfferings/requestModifyEdgeOffering', requestModifyEdgeOffering);
}
export function* watchRequestRemoveEdgeOffering() {
    yield takeLatest('edgeOfferings/requestRemoveEdgeOffering', requestRemoveEdgeOffering);
}
export function* watchRequestTargetProfileEdgeOfferings() {
    yield takeLatest('edgeOfferings/requestTargetProfileEdgeOfferings', requestTargetProfileEdgeOfferings);
}
